import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9ad1fd2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing radius-7" }
const _hoisted_2 = { class: "card-head box-shadow bg-white p-15 p-sm-20 p-md-25 radius-7" }
const _hoisted_3 = { class: "stock-toolbar" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h5", { class: "mb-1 fw-bold" }, "Estoque de produtos"),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-0 text-muted fs-14" }, "Controle entradas, ajustes e saldo atual de cada produto.")
], -1))
const _hoisted_5 = { class: "stock-search" }
const _hoisted_6 = { class: "card-body p-15 p-sm-20 p-md-25 mt-10" }
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = { class: "table text-nowrap align-middle mb-0 stock-table" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0" }, "Produto"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" }, "Estoque"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" }, "Mínimo"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" }, "Status"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" }, "Adicionar"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 pe-0" }, "Definir estoque")
  ])
], -1))
const _hoisted_10 = { class: "shadow-none lh-1 fw-medium text-black-emphasis ps-0 stock-product-cell" }
const _hoisted_11 = { class: "stock-product-name" }
const _hoisted_12 = { class: "stock-product-sku" }
const _hoisted_13 = { class: "shadow-none lh-1 fw-bold text-black-emphasis" }
const _hoisted_14 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_15 = ["onUpdate:modelValue"]
const _hoisted_16 = { class: "shadow-none lh-1" }
const _hoisted_17 = { class: "shadow-none lh-1" }
const _hoisted_18 = { class: "stock-action" }
const _hoisted_19 = ["onUpdate:modelValue"]
const _hoisted_20 = ["disabled", "onClick"]
const _hoisted_21 = { class: "shadow-none lh-1 pe-0" }
const _hoisted_22 = { class: "stock-action" }
const _hoisted_23 = ["onUpdate:modelValue"]
const _hoisted_24 = ["disabled", "onClick"]
const _hoisted_25 = {
  key: 1,
  class: "stock-empty radius-7"
}
const _hoisted_26 = { class: "d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center mt-20" }
const _hoisted_27 = { class: "fs-14 text-muted mb-10 mb-sm-0" }
const _hoisted_28 = { "aria-label": "Paginação de estoque" }
const _hoisted_29 = { class: "pagination mb-0" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
            type: "text",
            class: "form-control shadow-none rounded-0 text-black radius-7",
            placeholder: "Buscar por nome ou SKU...",
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.debouncedLoadStock(1)))
          }, null, 544), [
            [_vModelText, _ctx.search]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.feedback.message)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["alert radius-7 mb-20", _ctx.feedback.type === 'error' ? 'alert-danger' : 'alert-success'])
          }, _toDisplayString(_ctx.feedback.message), 3))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("table", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: product.id
              }, [
                _createElementVNode("td", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(product.name || 'Sem nome'), 1),
                  _createElementVNode("small", _hoisted_12, _toDisplayString(product.sku || '-'), 1)
                ]),
                _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.stockQuantity(product)), 1),
                _createElementVNode("td", _hoisted_14, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": ($event: any) => ((_ctx.stockForms[product.id].minimum_quantity) = $event),
                    type: "number",
                    min: "0",
                    class: "form-control form-control-sm stock-number-input radius-7"
                  }, null, 8, _hoisted_15), [
                    [
                      _vModelText,
                      _ctx.stockForms[product.id].minimum_quantity,
                      void 0,
                      { number: true }
                    ]
                  ])
                ]),
                _createElementVNode("td", _hoisted_16, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["badge radius-7", _ctx.stockStatus(product).className])
                  }, _toDisplayString(_ctx.stockStatus(product).label), 3)
                ]),
                _createElementVNode("td", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((_ctx.stockForms[product.id].add_quantity) = $event),
                      type: "number",
                      min: "1",
                      class: "form-control form-control-sm stock-number-input radius-7"
                    }, null, 8, _hoisted_19), [
                      [
                        _vModelText,
                        _ctx.stockForms[product.id].add_quantity,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-success radius-7",
                      disabled: _ctx.loadingProductId === product.id,
                      onClick: ($event: any) => (_ctx.addStock(product))
                    }, " Adicionar ", 8, _hoisted_20)
                  ])
                ]),
                _createElementVNode("td", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((_ctx.stockForms[product.id].set_quantity) = $event),
                      type: "number",
                      min: "0",
                      class: "form-control form-control-sm stock-number-input radius-7"
                    }, null, 8, _hoisted_23), [
                      [
                        _vModelText,
                        _ctx.stockForms[product.id].set_quantity,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-light radius-7",
                      disabled: _ctx.loadingProductId === product.id,
                      onClick: ($event: any) => (_ctx.adjustStock(product))
                    }, " Salvar ", 8, _hoisted_24)
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      (!_ctx.isLoading && _ctx.products.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, " Nenhum produto encontrado para controlar estoque. "))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, " Página " + _toDisplayString(_ctx.currentPage) + " de " + _toDisplayString(_ctx.pagination.last_page || 1) + " — Total de " + _toDisplayString(_ctx.pagination.total || _ctx.products.length) + " produtos ", 1),
        _createElementVNode("nav", _hoisted_28, [
          _createElementVNode("ul", _hoisted_29, [
            _createElementVNode("li", {
              class: _normalizeClass(["page-item", { disabled: _ctx.currentPage <= 1 }])
            }, [
              _createElementVNode("button", {
                type: "button",
                class: "page-link",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadStock(_ctx.currentPage - 1))),
                disabled: _ctx.currentPage <= 1
              }, "Anterior", 8, _hoisted_30)
            ], 2),
            _createElementVNode("li", {
              class: _normalizeClass(["page-item", { disabled: _ctx.currentPage >= _ctx.pagination.last_page }])
            }, [
              _createElementVNode("button", {
                type: "button",
                class: "page-link",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadStock(_ctx.currentPage + 1))),
                disabled: _ctx.currentPage >= _ctx.pagination.last_page
              }, "Próxima", 8, _hoisted_31)
            ], 2)
          ])
        ])
      ])
    ])
  ]))
}